import anchorme from "anchorme"; // ES6 / Typescript style imports
import MarkdownIt from 'markdown-it'

export default {
  formatParagraphs: (text) => {

    text = anchorme(text)

    let pars = text.split('\\')

    // format list
    pars.forEach((par,index) => {
      let list = par.split('*')
      let parList = list[0]
      if(list.length > 1) {
        parList += '<ul class="text-list">'
        for (let i =1; i < list.length; i++) {
          parList += '<li>' + list[i] + '</li>'
        }
        parList += '</ul>'
      }
      pars[index] = parList
    });

    return pars.join('<br/>')

  }
}


// WEBPACK FOOTER //
// ./src/utils/textFormat.js